import React from "react";
import "./BlueBorderBtn.css";

const BlueBorderBtn = ({
  btnText,
  onClick,
  type = "button",
  className = "",
  children,
}) => {
  return (
    <button
      type={type}
      className={`blue_border_btn ${className}`}
      onClick={onClick}
    >
      {children || btnText}
    </button>
  );
};

export default BlueBorderBtn;
